import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, filter } from 'rxjs/operators';
import { userPermissionListActions } from '../actions';
import { UserPermissionList } from '../models';
import { UserPermissionListResource } from '../services';

@Injectable()
export class UserPermissionListEffects {
  constructor(
    private userPermissionListActions$: Actions,
    private api: UserPermissionListResource
  ) {}

  @Effect()
  loadById$: Observable<Action> = this.userPermissionListActions$.pipe(
    ofType(userPermissionListActions.LOAD_BY_ID),
    map((action: userPermissionListActions.LoadById) => action.payload),
    filter((id) => !!id),
    mergeMap((id) =>
      this.api.get(<string>id).pipe(
        map((userPermissionList: UserPermissionList) => new userPermissionListActions.LoadByIdSuccess({
          ...userPermissionList,
          applications: userPermissionList.applications,
        }))
      )
    ),
    catchError((error) =>
      of(
        new userPermissionListActions.LoadFailed({
          error: error,
          message: 'Unable to load user permissions',
        })
      )
    )
  );
}
